const acceptFiles = [
  'image/png',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/webp',
];

export default acceptFiles.join(', ');
